import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import { Message, useStyles, WrapperForm } from "./style";
import LoadingComponent from "../../../../components/loading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import moment from "moment-timezone";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import InputFormDocPlace from "../../../../components/form/input";
import DateRangePickerDocPlace from "../../../../components/form/dateRangePickerDocPlace";
import {
  getDocTypeAttributeList,
  getDocTypeList1,
} from "../../../../store/docType/actions";
import { Autocomplete, Box, TextField } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const OriginTypeList = [
  { value: "SCANNER", label: "SCANNER" },
  { value: "WEB_UI", label: "WEB_UI" },
];

export const criteriaOptions = [
  { value: "=", label: "Equal" },
  { value: ">=", label: "Greater or equal to" },
  { value: "<=", label: "Smaller or equal to" },
  { value: "val%", label: "Starts with" },
  { value: "%val", label: "Ends with" },
  { value: "%val%", label: "Contain" },
];
function subtractMonths(date, months) {
  date.setMonth(date.getMonth() - months);

  return date;
}
export function NewFilterDocPlace(props) {
  const classes = useStyles();
  const [showNew, setShowNew] = useState(false);
  const [value, setValue] = useState({ value: "", error: false });

  const [doctypeList, setDoctypeList] = useState([]);
  const [documentType, setDocumentType] = useState({});

  const [criteria, setCriteria] = useState({});

  const [attributesList, setAttributesList] = useState([]);
  const [attribute, setAttribute] = useState({});
  const [attributeDefault, setAttributeDefault] = useState({});
  const [selectedDateFrom, handleDateChangeFrom] = useState(
    subtractMonths(new Date(), 1)
  );
  const [selectedDateTo, handleDateChangeTo] = useState(new Date());

  const notify = (msj, event) => toast[event](msj);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState({
    value: [null, null],
    error: false,
    notReady: false,
  });

  const { responseDocType1, loading } = useSelector((state) => ({
    responseDocType1: state.DocType.responseDocType1,
    loading: state.DocType.loadingDocType1,
  }));

  const filterRef = useRef(null);

  const { responseDocTypeAttribute, loadingDocTypeAttribute } = useSelector(
    (state) => ({
      responseDocTypeAttribute: state.DocType.responseDocTypeAttribute,
      loadingDocTypeAttribute: state.DocType.loadingDocTypeAttribute,
    })
  );
  useEffect(() => {
    function handleClickOutside(event) {
      const dateDialog = document.querySelector(".MuiDialog-root");
      if (dateDialog && dateDialog.contains(event.target)) {
        return;
      }
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        close();
      }
    }

    if (showNew) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNew]);

  useEffect(() => {
    setShowNew(props.show);
    
    // Only fetch if modal is opening and we don't already have data
    if (props.show && !responseDocType1?.data) {
      dispatch(
        getDocTypeList1(
          {
            page: 1,
            pageSize: 1000,
            sortBy: "name",
            sortOrder: 1,
            filtered: false,
          },
          navigate
        )
      );
    }
  }, [props.show]);

  useEffect(() => {
    if (responseDocType1?.data?.length > 0) {
      let l = [];
      responseDocType1.data.map((item) => {
        l.push({
          value: item.id,
          label: item.name,
        });
      });
      if (l.length > 0) {
        setAttributeDefault({ value: l[0].value, label: l[0].label });
      }
      setDoctypeList(l);
    }
  }, [responseDocType1]);

  useEffect(() => {
    if (responseDocTypeAttribute?.data?.length > 0 && documentType !== "-1") {
      let l = [];
      Object.keys(responseDocTypeAttribute.data[0]).map((item, i) => {
        l.push({
          value: responseDocTypeAttribute.data[0][item].alias,
          label: item,
        });
      });
      setAttributesList(l);
    }
  }, [responseDocTypeAttribute]);

  const close = () => {
    setDocumentType("");
    setAttribute("");
    setCriteria({});
    setValue("");
    setDateRange({ value: [null, null], error: false, notReady: false });
    props.close();
  };

  const newAcction = () => {
    let date1 = dateRange.value[0];
    let date2 = dateRange.value[1];
    date1 = moment(date1).format("YYYY-MM-DD");
    date2 = moment(date2).format("YYYY-MM-DD");
    let isValid =
      !dateRange.error &&
      date1 &&
      date2 &&
      date1.toString() !== "Invalid Date" &&
      date2.toString() !== "Invalid Date";
    if (isValid) {
      let filter = {
        ...(documentType.length > 0
          ? { docTypeId: documentType }
          : { docTypeId: "" }),
        criteria: [
          {
            ...(attribute.length > 0 ? { field: attribute } : { field: "" }),
            ...(criteria.length > 0
              ? { operator: criteria }
              : { operator: "" }),
            value: value.value,
          },
        ],
      };

      let fromDate = date1 !== "Invalid date" ? date1 : undefined;
      let toDate = date2 !== "Invalid date" ? date2 : undefined;

      let nameDocType = "";
      responseDocType1.data.map((item) => {
        if (item.id === documentType) {
          nameDocType = item.name;
        }
      });
      filter.docTypeName = nameDocType;

      props.doctypeText(nameDocType);
      props.done({
        filter: filter,
        fromDate: fromDate,
        toDate: toDate,
      });
      close();
    } else {
      notify("Start Date is more recent than End Date", "error");
    }
  };

  const setValueAttribute = (event) => {
    setAttribute(event.target.value);
    setCriteria("");
  };

  const setValueCriteria = (event) => {
    setCriteria(event.target.value);
  };

  const setValueDoctype = (event, value) => {
    setAttribute("");
    setCriteria("");

    if (value?.value) {
      setDocumentType(value.value);

      if (value?.value !== "-1") {
        dispatch(getDocTypeAttributeList({ id: value.value }, navigate));
      } else {
        setAttributesList([]);
      }
    }
  };
  const onChangeRange = () => {
    //DOC-1604 / DOC-1754
    let date1 = dateRange.value[0];
    let date2 = dateRange.value[1];
    let isValid =
      !dateRange.error &&
      date1 &&
      date2 &&
      date1.toString() !== "Invalid Date" &&
      date2.toString() !== "Invalid Date";
    // if (isValid) refreshDashboard();
  };

  return (
    <>
      {showNew && (
        <div
          ref={filterRef}
          style={{
            position: "absolute",
            right: "20px",
            top: "200px",
            zIndex: 9999,
            width: "340px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
            padding: "16px",
            border: "1px solid #ccc",
            fontFamily: "Roboto, sans-serif",
          }}
        >
          <LoadingComponent
            show={loading || loadingDocTypeAttribute}
            text={loading ? "Getting Document Types" : "Adding new Filter..."}
          />

          <IconButton
            onClick={close}
            size="small"
            sx={{
              position: "absolute",
              top: "8px",
              right: "8px",
              color: "#0076FF",
              backgroundColor: "transparent",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#0076FF",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="h6"
            style={{
              marginBottom: "8px",
              fontWeight: "bold",
              color: "#0076FF",
            }}
          >
            Filters
          </Typography>

          <Grid container spacing={1}>
            {/* Section: Document Type */}
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                style={{
                  color: "#0076FF",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Document Type
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  disablePortal
                  id="doctype-id"
                  options={doctypeList}
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.value}>
                      {option.label}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} label="Document Type" focused />
                  )}
                  onChange={setValueDoctype}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                disablePortal
                id="attribute-id"
                options={attributesList}
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => (
                  <Box component="li" {...props} key={option.value}>
                    {option.label}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Attribute" focused />
                )}
                onChange={(e, value) => {
                  setAttribute(value?.value || "");
                  setCriteria("");
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputFormDocPlace
                  id={"value"}
                  field={value}
                  setField={setValue}
                  required={true}
                  type="text"
                  label="Value"
                  helperText="Enter value!"
                />
              </FormControl>
            </Grid>

            {/* Section: Type */}
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                style={{
                  color: "#0076FF",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Type
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                disablePortal
                id="criteria-id"
                options={criteriaOptions}
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => (
                  <Box component="li" {...props} key={option.value}>
                    {option.label}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Criteria" focused />
                )}
                onChange={(e, value) => {
                  setCriteria(value?.value || "");
                }}
              />
            </Grid>

            {/* Section: Modified */}
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                style={{
                  color: "#0076FF",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Modified
              </Typography>
              <FormControl fullWidth>
                <Select disabled value="">
                  <MenuItem value="">(Placeholder)</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Section: Date Range */}
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                style={{
                  color: "#0076FF",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Date Range
              </Typography>
              <DateRangePickerDocPlace
                id={"dateSearch"}
                field={dateRange}
                setField={setDateRange}
                required={true}
                startDateText="From"
                endDateText="To"
                helperText=""
                execute={onChangeRange}
                displayMessage={false}
              />
            </Grid>

            {/* Button */}
            <Grid item xs={12}>
              <Button
                onClick={newAcction}
                variant="contained"
                fullWidth
                style={{
                  marginTop: "16px",
                  backgroundColor: "#0076FF",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "4px",
                }}
              >
                Apply Filters
              </Button>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}

export default NewFilterDocPlace;
